import {Route, Routes} from 'react-router-dom';
import {MyPerformanceGate, PerformanceGate} from './PerformanceGate';
import {MyPerformance} from './MyPerformance';
import {PerformanceOverview} from './PerformanceOverview';
import {AgentPerformanceDetail} from './AgentPerformanceDetail';
import styles from './performance.module.scss';

/**
 * Customer Support › Performance, its own side tab beside Tickets. It does
 * not sit inside the Tickets layout, so none of the ticket tabs, toolbar or
 * ticket-list query exist here. The team and agent routes are
 * SUPERADMIN-only; `me` is a support agent's own numbers.
 */
export const PerformanceRoutes = () => (
  <div className={styles.root}>
    <Routes>
      <Route
        index
        element={
          <PerformanceGate>
            <PerformanceOverview />
          </PerformanceGate>
        }
      />
      <Route
        path="me"
        element={
          <MyPerformanceGate>
            <MyPerformance />
          </MyPerformanceGate>
        }
      />
      <Route
        path="agent/:agentId"
        element={
          <PerformanceGate>
            <AgentPerformanceDetail />
          </PerformanceGate>
        }
      />
    </Routes>
  </div>
);
